import type { InlineGridSection } from '#types/components/product/list'
import type { Section } from '#types/page'
import type { InjectionKey } from 'vue'

export interface SectionProvider {
  fullHeight: boolean
  lazy: boolean
  name: string
  section: Section | InlineGridSection | undefined
  position?: number
  parent?: SectionProvider
}

export const SectionContextKey: InjectionKey<SectionProvider> = Symbol('SectionContextKey')
